import { IModalMethods } from "@/interfaces/Modal";
import {
  ElementRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Col, Form, Row } from "react-bootstrap";
import { SubmitErrorHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { INVALID_FORM_MESSAGE } from "@/constants/validatorMessages";
import Modal from "@/components/atoms/Modal";
import { NoteForm } from "@/interfaces/Note";

interface StoreNoteModalProps {
  onSubmit: (data: NoteForm) => void;
  /** Transmis tel quel au Modal : permet à l'appelant de rouvrir la vue qu'il
   *  avait refermée pour éviter d'empiler deux modales. */
  onHide?: () => void;
}

const StoreNoteModal: ForwardRefRenderFunction<
  IModalMethods,
  StoreNoteModalProps
> = ({ onSubmit, ...props }, ref) => {
  const ModalRef = useRef<ElementRef<typeof Modal>>(null);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<NoteForm>();

  const showOrHiddenModal = (message?: string) => {
    reset();
    ModalRef.current?.showOrHiddenModal();
    setValue("message", message || "");
  };

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  const onError: SubmitErrorHandler<NoteForm> = () => {
    toast.error(INVALID_FORM_MESSAGE);
  };

  return (
    <Modal
      ref={ModalRef}
      title="Ajouter une note"
      onSubmit={handleSubmit(onSubmit, onError)}
      {...props}
    >
      <Row className="gx-3">
        <Col className="mt-2">
          <Form.Label>
            Note <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
            as="textarea"
            type="text"
            {...register("message", {
              required: "Ce champ est obligatoire.",
              minLength: {
                value: 3,
                message: "Ce champ doit contenir au moins 3 caractères.",
              },
              maxLength: {
                value: 500,
                message: "Ce champ doit contenir au plus 500 caractères.",
              },
            })}
            isInvalid={!!errors.message}
            style={{ minHeight: 100 }}
          />
          <Form.Control.Feedback type="invalid">
            {errors.message?.message}
          </Form.Control.Feedback>
        </Col>
      </Row>
    </Modal>
  );
};

export default forwardRef(StoreNoteModal);
